import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { keys, isString } from 'lodash';
import FontAwesome from 'react-fontawesome';

import WhiteLoadingSpinner from 'svg/white-loading-spinner.svg';
import styles from './status-banner.less';

// TODO: Create these six separate component factories instead
const STATUS_BANNER_TYPE_ENUM = Object.freeze({
  neutral: 'neutral',
  warning: 'warning',
  danger: 'danger',
  info: 'info',
  success: 'success',
});

const StatusBanner = ({
  isDismissable,
  isLoading,
  isVisible,
  children,
  className,
  type,
  muted,
  gutter,
  onDismissed,
  icon,
  iconClassName,
}) => {
  const _className = classnames(
    styles.root,
    { [styles[type]]: type },
    { [styles.muted]: muted },
    { [styles.isVisible]: isVisible },
    { [styles.gutter]: gutter },
    className
  );

  const transformChildren = child => {
    const props = {
      className: classnames(
        styles['content-inner'],
        !isString(child) && child.props.className
      ),
    };

    return isString(child)
      ? React.createElement('p', props, child)
      : React.cloneElement(child, props);
  };

  return (
    <div className={_className} data-test-id={'status-banner-' + type}>
      {icon && !isLoading && (
        <FontAwesome
          data-test-id="status-banner-icon"
          name={icon}
          className={classnames(styles.icon, iconClassName)}
        />
      )}

      {/* fix: CHARTS-2801 - `isVisible` must be used in conjunction with `isLoading` here
       to prevent "unstyled" id collisions when StatusBanner is hidden */}
      {isLoading && isVisible && (
        <WhiteLoadingSpinner className={styles.isLoading} />
      )}

      <div
        data-test-id="status-banner-content"
        className={classnames(styles.content)}
      >
        {React.Children.map(children, transformChildren)}
      </div>

      {isDismissable && (
        <FontAwesome
          data-test-id="status-banner-dismiss-icon"
          name="close"
          className={classnames(styles.icon, styles.close)}
          onClick={onDismissed}
        />
      )}
    </div>
  );
};

StatusBanner.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  gutter: PropTypes.bool,
  isDismissable: PropTypes.bool,
  icon: PropTypes.string,
  iconClassName: PropTypes.string,
  isLoading: PropTypes.bool,
  isVisible: PropTypes.bool,
  onDismissed: PropTypes.func,
  type: PropTypes.oneOf(keys(STATUS_BANNER_TYPE_ENUM)),
  muted: PropTypes.bool,
};

StatusBanner.defaultProps = {
  className: '',
  gutter: true,
  iconClassName: '',
  isDismissable: true,
  isVisible: false,
  isLoading: false,
  onDismissed: () => {},
  type: STATUS_BANNER_TYPE_ENUM.neutral,
  muted: false, // Muted is used in conjunction with type to create color variants which are more subtle.
};

export default StatusBanner;
export { StatusBanner, STATUS_BANNER_TYPE_ENUM };
